import { render } from "./SettingsCategoryView.vue?vue&type=template&id=4fb9f0ec"
import script from "./SettingsCategoryView.vue?vue&type=script&lang=js"
export * from "./SettingsCategoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__